var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleeperBlocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 18,
    viewBox: "0 0 51 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#979797",
    strokeWidth: 0.75,
    transform: "matrix(-1 0 0 1 51 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M3.125.375h44.6c.719 0 1.374.295 1.85.771.474.475.769 1.13.769 1.852v15.086c0 .721-.294 1.378-.77 1.853a2.603 2.603 0 01-1.85.77h-44.6a2.609 2.609 0 01-1.85-.772 2.61 2.61 0 01-.769-1.851V2.998c0-.722.294-1.378.77-1.854a2.606 2.606 0 011.85-.769z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.648,
    height: 15.721,
    x: 4.458,
    y: 2.68,
    fill: "#C3C3BE",
    rx: 2
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2BAC36",
    d: "M2.04 2.687l20.223 7.762L39.82 3.357a.5.5 0 01.61.196l.04.08a.5.5 0 01-.275.651l-16.563 6.69 16.686 6.406a.5.5 0 01-.359.933l-17.687-6.789L2.18 19.643a.5.5 0 01-.61-.196l-.04-.08a.5.5 0 01.275-.651l19.1-7.718L1.681 3.62a.5.5 0 01.359-.933z"
  }))));
}
export default SvgSleeperBlocked;